import { ChildProps } from "ts/types";

export default function PageContainer({ children }: ChildProps) {
  return (
    <div className="rounded-lg border border-gray-200 bg-white px-4 py-8 sm:px-10">
      {children}
    </div>
  );
}
